import AbstractCancelRequestService from 'services/http/AbstractCancelRequestService';

class KidZoneCancelRequestService extends AbstractCancelRequestService {}

export default new KidZoneCancelRequestService();
